
import ngAria from "angular-aria";
import ngSanitize from "angular-sanitize";
import uiBootstrap from "angular-ui-bootstrap";

import TbAppConfigDataServiceModule from "../../config/tb-app-config/TbAppConfigDataService";
import TbAuthServiceModule from "tbClient/services/auth/index";
import Assert from "tbAssert";

const mScopeSvc = new WeakMap();
const mTimeoutSvc = new WeakMap();
const mWindowSvc = new WeakMap();
const mLogSvc = new WeakMap();
const mAuthSvc = new WeakMap();
const mUserProfile = new WeakMap();

class TbSignOutController {
    constructor($scope, $window, $timeout, $log, TbAuthService) {

        Assert.StrictAssert($scope != null, "Assertion Failure: Missing Scope Service Dependency");
        Assert.StrictAssert($window != null, "Assertion Failure: Missing Window Service Dependency");
        Assert.StrictAssert($timeout != null, "Assertion Failure: Missing Timeout Service Dependency");
        Assert.StrictAssert($log != null, "Assertion Failure: Missing Log Service Dependency");

        Assert.StrictAssert(TbAuthService != null, "Assertion Failure: Missing Auth0 Service Dependency");

        mScopeSvc.set(this, $scope);
        mWindowSvc.set(this, $window);
        mTimeoutSvc.set(this, $timeout);
        mLogSvc.set(this, $log);
        mAuthSvc.set(this, TbAuthService);

        mUserProfile.set(this, null);
        //$scope.$watch(
        //    () => {
        //        return this._authSvc.isAuthenticated;
        //    },
        //    (newVal, oldVal) => {
        //        if (newVal !== oldVal) {
        //            this._updateAuthVars();
        //        }
        //    },
        //    true
        //);
    }

    get _authSvc() {
        return mAuthSvc.get(this);
    }

    get userName() {
        let userProfile = mUserProfile.get(this);
        if (userProfile != null) {
            return userProfile.name;
        }
        else {
            return null;
        }
    }

    get isSignedIn() {
        return this._authSvc.isAuthenticated();
    }

    $onInit() {
        mLogSvc.get(this).debug("In Tb Sign Out Init!");
        this.loadProfile();
    }

    loadProfile() {
        const timeoutSvc = mTimeoutSvc.get(this);
        return this._authSvc.getProfile()
            .then((profile) => {
                timeoutSvc(() => { mUserProfile.set(this, profile); }, 0);
            })
            .catch((err) => {
                mLogSvc.get(this).debug("Error retrieving profile", err);
                timeoutSvc(() => { mUserProfile.set(this, null); }, 0);
            });
    }

    logout() {
        mLogSvc.get(this).debug("Logging out user...");
        this._authSvc.logout();
    }
}

TbSignOutController.$inject = [
    "$scope",
    "$window",
    "$timeout",
    "$log",
    "TbAuthService"
];

TbSignOutController.template = require("./TbSignOut.tpl.html");
TbSignOutController.controllerAs = "tbSignOutCtrl";

TbSignOutController.dependencies = [
    ngAria,
    ngSanitize,
    uiBootstrap,
    TbAuthServiceModule,
    TbAppConfigDataServiceModule
];

export default TbSignOutController;



//////////////////
// WEBPACK FOOTER
// ./src/directives/user-auth/TbSignOutController.js
// module id = QymV
// module chunks = 1